
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.159 1.627L1.627 3.16 11.968 13.5l1.532-1.532L3.159 1.628zm9.575 10.341l-.766.766-7.66-7.66.765-.766 7.661 7.66zM5.245 1.908c.667.203 1.19.726 1.393 1.393a2.1 2.1 0 011.394-1.393A2.099 2.099 0 016.638.514a2.096 2.096 0 01-1.393 1.394zM2.348 5.675A2.78 2.78 0 01.5 7.523a2.78 2.78 0 011.848 1.848 2.78 2.78 0 011.848-1.848 2.783 2.783 0 01-1.848-1.848zM7.523 3.96c.472.144.84.514.985.986.144-.472.514-.842.985-.986a1.483 1.483 0 01-.985-.986 1.484 1.484 0 01-.985.986zM9.92.5c-.164.538-.586.96-1.124 1.125.54.164.96.586 1.125 1.125.164-.539.586-.96 1.124-1.125A1.695 1.695 0 019.92.5z","fill":"#fff"}})])
          )
        }
      }
    